/* pamela-clipart-registry.js
   Manifest-based registry for pamela-clipart-library.js
   Loads Shopify-hosted JSON once and provides PAMELA_CLIPART_ENSURE().
*/
(function () {
  function slugify(s) {
    return String(s || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function isSizeLike(s) {
    return /^\d{2,4}\s*x\s*\d{2,4}$/i.test(String(s || "").trim());
  }

  // Remove UUID-ish tail from names so the UI shows clean labels again
  // Example: "Dog 12deb6ae-bc33-49b8-8391-ff06f44ff89a" => "Dog"
function cleanDisplayName(name) {
  let n = String(name || "").trim().toLowerCase();

  // remove file extension if present
  n = n.replace(/\.svg$/i, "");

  // remove trailing numbers (like 1234 or 1234a)
  n = n.replace(/\s*\d+[a-z]?\s*$/i, "");

  // normalize spaces
  n = n.replace(/\s+/g, " ").trim();

  // fallback if empty (like "2505.svg")
  if (!n) return "";

  // capitalize nicely
  n = n.replace(/\b\w/g, (c) => c.toUpperCase());

  return n;
}

  function normalizeSubcategory(category, subcategory) {
    const cat = String(category || "").trim().toLowerCase();
    const sub = String(subcategory || "").trim();
    const key = sub.toLowerCase().replace(/&/g, "and").replace(/\s+/g, " ");

    if (cat === "animals" && (key === "deer" || key === "deer and elk")) {
      return "Deer And Elk";
    }

    return sub;
  }

  // Manual overrides you asked for (exact matches after cleaning)
  const CATEGORY_OVERRIDES = {
    // Animals
    "Farm Cow": "Animals",
    "Frog": "Animals",

    // Bugs & Insects
    "Ladybug": "Bugs & Insects",
    "Butterfly": "Bugs & Insects",
    "Dragonfly": "Bugs & Insects",

    // Flowers/Plants
    "Pinecones": "Flowers/Plants",
    "Daffodil": "Flowers/Plants",
    "Grapes": "Flowers/Plants",
    "Iris": "Flowers/Plants",
    "Ivy Vines": "Flowers/Plants",
    "Shamrocks": "Flowers/Plants",
  };

  // Special case: catch Pine Cones even if spelled differently
  function isPineConesLike(cleanedName) {
    const s = String(cleanedName || "").trim().toLowerCase();
    // pinecone, pinecones, pine cone, pine cones, pine-cones, pine-cone
    return /^pine[\s-]?cones?$/.test(s);
  }

  // Keyword-based fallback ONLY used when category is missing/junk (like 800x800)
  function inferCategoryFromName(name) {
    const n = String(name || "").toLowerCase();

    // Bugs & Insects
    if (/(ladybug|butterfly|dragonfly|bee|bees|wasp|wasps|ant|ants|spider|spiders|bug|bugs|insect|insects)/.test(n))
      return "Bugs & Insects";

    // Religious
    if (/(cross|crucifix|jesus|christ|bible|pray|prayer|angel|dove|church|ichthys|inri)/.test(n))
      return "Religious";

    // Wedding / Rings
    if (/(rings|wedding|marriage|couple|bride|groom|anniversary|hearts?)/.test(n))
      return "Rings";

    // Flowers/Plants
    if (/(rose|roses|lily|lilies|tulip|flower|flowers|daisy|sunflower|violet|orchid|ivy|vines?|shamrock|grapes?|pine\s*-?\s*cones?|pinecone|daffodil|iris)/.test(n))
      return "Flowers/Plants";

    // Military / patriotic
    if (/(flag|usa|american|veteran|army|navy|marine|air force|coast guard)/.test(n))
      return "Patriotic";

    // Sports / hobbies
    if (/(golf|fishing|hunt|hunting|baseball|basketball|football|soccer)/.test(n))
      return "Hobbies";

    // Animals (expanded)
    if (/(bear|deer|buck|elk|fish\b|bass|dog|cat|horse|cow|frog|eagle|bird|cardinal|dolphin|lion|wolf|duck|goose|rabbit|bunny|squirrel)/.test(n))
      return "Animals";

    return "Uncategorized";
  }

  function normalizeCategory(cat, cleanedName) {
    // 1) Manual overrides win
    if (CATEGORY_OVERRIDES[cleanedName]) return CATEGORY_OVERRIDES[cleanedName];

    // 1b) Pine Cones variants
    if (isPineConesLike(cleanedName)) return "Flowers/Plants";

    // 2) Use manifest category if it is valid (and not junk like 800x800)
    const c = String(cat || "").trim();
    if (c && !isSizeLike(c) && c.toLowerCase() !== "uncategorized") {
      // If the manifest says "Flowers", relabel to "Flowers/Plants" for consistency
      if (c.toLowerCase() === "flowers") return "Flowers/Plants";
      return c;
    }

    // 3) Infer from name
    return inferCategoryFromName(cleanedName);
  }

  async function loadManifestOnce() {
    // Already loaded?
    if (Array.isArray(window.PAMELA_CLIPART_ALL) && window.PAMELA_CLIPART_ALL.length) {
      return window.PAMELA_CLIPART_ALL;
    }
    // In-flight?
    if (window.__PAMELA_CLIPART_MANIFEST_PROMISE) {
      return window.__PAMELA_CLIPART_MANIFEST_PROMISE;
    }

    const url = "https://cm-editor-server.onrender.com/api/svg-library?key=cre1ative2mon3umen8t4web5site6bui4ldin9g7edi67tor3";
    if (!url) throw new Error("PAMELA_CLIPART_MANIFEST_URL is missing on window.");

    window.__PAMELA_CLIPART_MANIFEST_PROMISE = fetch(url, { cache: "no-store" })
      .then(async (r) => {
        if (!r.ok) throw new Error("Manifest fetch failed: " + r.status + " " + r.statusText);
        return r.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) throw new Error("Manifest JSON is not an array.");

        const all = data
          .map((it) => {
            const rawName = String(it.name || "");
            const cleanedName = cleanDisplayName(rawName);
            const category = normalizeCategory(it.category, cleanedName);
            const subcategory = normalizeSubcategory(category, it.subcategory);

        return {
          id: String(it.id || ""),
          name: cleanedName,          // clean label shown in UI
          rawName: rawName,           // keep original around for future order metadata
          category,
          categoryId: slugify(category || "Uncategorized"),
          subcategory,
          url: "https://cm-editor-server.onrender.com" + String(it.url || ""),
        };
          })
          .filter((it) => it.url);

        const byCat = {};
        for (const it of all) {
          const k = it.categoryId || "uncategorized";
          (byCat[k] ||= []).push(it);
        }

        // Globals the library can use
        window.PAMELA_CLIPART_ALL = all;
        window.PAMELA_CLIPART_BY_CAT = byCat;
        window.PAMELA_CLIPART = all;

        window.PAMELA_CLIPART_CATEGORIES = Object.keys(byCat)
          .sort((a, b) => a.localeCompare(b))
          .map((id) => {
            const first = byCat[id] && byCat[id][0] ? byCat[id][0].category : id;
            return { id, label: first };
          });

        return all;
      })
      .catch((e) => {
        console.error("[Pamela Clipart Registry] Manifest load error:", e);
        throw e;
      });

    return window.__PAMELA_CLIPART_MANIFEST_PROMISE;
  }

  // The library calls: await window.PAMELA_CLIPART_ENSURE(activeCat)
  // =============================
// Subcategory helper
// =============================
window.PAMELA_GET_SUBCATEGORIES = function (catId) {
  const cid = slugify(catId || "") || "uncategorized";
  const items = window.PAMELA_CLIPART_BY_CAT?.[cid] || [];

  const map = {};

  for (const it of items) {
    const sub = String(it.subcategory || "").trim();
    if (!sub) continue;

    const key = sub.toLowerCase();
    if (!map[key]) {
      map[key] = {
        id: key,
        label: sub
      };
    }
  }

  return Object.values(map).sort((a, b) =>
    a.label.localeCompare(b.label)
  );
};

  window.PAMELA_CLIPART_ENSURE = async function (catId) {
    const all = await loadManifestOnce();

    const cid = slugify(catId || "") || "uncategorized";
    window.PAMELA_CLIPART_BY_CAT ||= {};
    window.PAMELA_CLIPART_BY_CAT[cid] ||= all.filter((it) => it.categoryId === cid);

    return true;
  };
})();
